import { render, staticRenderFns } from "./DonutChartForPoint.vue?vue&type=template&id=de422248"
import script from "./DonutChartForPoint.vue?vue&type=script&lang=js"
export * from "./DonutChartForPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports